import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Destinations", path: "/destinations" },
    { name: "Services", path: "/services" },
    { name: "Products", path: "/products" },
    { name: "Membership", path: "/membership" },
    { name: "About", path: "/about" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <nav 
        data-testid="navbar"
        className="fixed top-0 left-0 right-0 z-50 glass border-b border-black/5"
      >
        <div className="container-custom">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link 
              to="/" 
              data-testid="nav-logo"
              className="flex items-center gap-3"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_build-sites-32/artifacts/cg4su8qh_photo_2026-04-05_22-55-36.jpg" 
                alt="Archipelago by Av Logo"
                className="w-12 h-12 object-contain"
              />
              <span className="font-['Playfair_Display'] text-xl font-semibold text-[#0E2954]">
                Archipelago<span className="text-[#D92525]"> by Av</span>
              </span>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-${link.name.toLowerCase()}-link`}
                  className={`text-sm font-medium transition-colors duration-300 link-hover ${
                    isActive(link.path)
                      ? "text-[#D92525]"
                      : "text-[#1A1A1A] hover:text-[#0E2954]"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* CTA Button */}
            <Link
              to="/membership"
              data-testid="nav-join-btn"
              className="hidden lg:block btn-primary text-sm"
            >
              Join Now
            </Link>

            {/* Mobile Menu Button */}
            <button
              data-testid="mobile-menu-btn"
              className="lg:hidden p-2"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? (
                <X className="w-6 h-6 text-[#1A1A1A]" />
              ) : (
                <Menu className="w-6 h-6 text-[#1A1A1A]" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-40 bg-white lg:hidden pt-20"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col p-6 gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-${link.name.toLowerCase()}-link`}
                  onClick={() => setIsOpen(false)}
                  className={`text-2xl font-['Playfair_Display'] ${
                    isActive(link.path)
                      ? "text-[#D92525]"
                      : "text-[#1A1A1A]"
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <Link
                to="/membership"
                data-testid="mobile-nav-join-btn"
                onClick={() => setIsOpen(false)}
                className="btn-primary text-center mt-4"
              >
                Join Now
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Spacer for fixed navbar */}
      <div className="h-20" />
    </>
  );
};

export default Navbar;
